"use client";

import {
  Avatar,
  AvatarFallback,
  cn,
  Item,
  ItemContent,
  ItemDescription,
  ItemMedia,
  ItemTitle,
} from "@atlas/core";
import { formatIsoDateTimeDisplay } from "@atlas/sdk";
import { UserIcon } from "lucide-react";

interface ICommentRowProps {
  displayName: string;
  timestampIso?: string;
  body: string;
  emptyBodyLabel?: string;
  className?: string;
}

export function CommentRow(props: ICommentRowProps) {
  const { displayName, timestampIso, body, emptyBodyLabel, className } = props;
  const rawTs = timestampIso?.trim() ?? "";
  const parsedForAttr = rawTs ? new Date(rawTs) : null;
  const dateOk =
    parsedForAttr != null && !Number.isNaN(parsedForAttr.getTime());
  const timeLabel = dateOk ? formatIsoDateTimeDisplay(rawTs) : rawTs || "";
  const dateTimeAttr =
    dateOk && parsedForAttr ? parsedForAttr.toISOString() : undefined;
  const trimmed = body.trim();

  return (
    <div
      className={cn(
        "border-0 not-last:border-b not-last:border-border not-last:pb-4",
        className,
      )}>
      <Item className="min-w-0 flex-1 items-start border-none p-0 hover:bg-transparent">
        <ItemMedia>
          <Avatar className="h-8 w-8 shrink-0" aria-label={displayName}>
            <AvatarFallback>
              <UserIcon className="size-4 text-muted-foreground" aria-hidden />
            </AvatarFallback>
          </Avatar>
        </ItemMedia>
        <ItemContent className="min-w-0 flex-1 gap-1">
          <ItemTitle className="p-0 text-sm font-semibold text-foreground shadow-none">
            {displayName}
          </ItemTitle>
          {timeLabel ? (
            <time
              dateTime={dateTimeAttr}
              className="block w-full min-h-[1em] text-left text-xs leading-normal text-muted-foreground">
              {timeLabel}
            </time>
          ) : null}
          {trimmed ? (
            <ItemDescription className="line-clamp-none whitespace-pre-wrap text-foreground">
              {body}
            </ItemDescription>
          ) : emptyBodyLabel ? (
            <ItemDescription className="line-clamp-none italic">
              {emptyBodyLabel}
            </ItemDescription>
          ) : null}
        </ItemContent>
      </Item>
    </div>
  );
}
